import type { ReactNode } from "react";

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
  children: ReactNode;
  padded?: boolean;
}

export function Card({ title, subtitle, right, children, padded = true }: Props) {
  return (
    <section className="surface">
      {(title || right) && (
        <header className="surface-header">
          <div>
            {title ? <h2 className="surface-title">{title}</h2> : null}
            {subtitle ? <p className="surface-subtitle">{subtitle}</p> : null}
          </div>
          {right}
        </header>
      )}
      <div className={padded ? "surface-body" : ""}>{children}</div>
    </section>
  );
}
